import { defineStore } from 'pinia'

export const pageParaStore = defineStore('pagePara', {
  state: () => {
    return {
      para: ''
    }
  },
  actions: {
    setPara(para: string) {
      this.para = para
    }
  }
})